// extracted by mini-css-extract-plugin
module.exports = {"button":"CallToActionLink_button__1-ZMt","donation":"CallToActionLink_donation__2JYcO","petition":"CallToActionLink_petition__2ERki"};